import "./card.scss";

function Card({ children, size="full", them="shadow", position, className, onClick, ...rest }) {
  return (
    <div 
      className={`card card-${size} card-${them} card-${position} ${className || ""}`} 
      onClick={onClick}
      {...rest}
    >
      {children}
    </div>
  );
}
export default Card;
